export default "__VITE_ASSET__BJlhYhBh__"